var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "modal-class": "agent-details-modal",
      "centered": "",
      "size": "xl",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      "content-class": "health-questionnaire-modal"
    },
    on: {
      "hidden": _vm.handleClose
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-agent-header d-flex justify-content-center align-items-center"
        }, [_c('h5', {
          staticClass: "modal-title"
        }, [_vm._v("Health Questionnaires")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isVisible,
      callback: function callback($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_c('b-container', [!_vm.loading ? _c('div', {
    staticClass: "d-flex justify-content-end align-items-center gap-2"
  }, [_c('button', {
    staticClass: "btn univ-btn sendBtn mb-0 mt-0 w-auto ps-4 pe-4 align-items-center",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.downloadHealthQuestion.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-download"
  }), _vm._v(" Download ")])]) : _vm._e(), _c('div', {
    staticClass: "notes-list-container"
  }, [_vm.loading ? _c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Spinning"
    }
  })], 1) : _vm._e(), !_vm.loading && _vm.health_questions.length === 0 ? _c('div', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_vm._v(" No health questionnaires found ")]) : _c('div', [_vm._l(_vm.health_questions, function (question, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "split-list"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(question.question)
      }
    }), _c('div', {
      staticClass: "split-yn-div"
    }, [_c('div', {
      staticClass: "form-check form-check-inline"
    }, [_c('input', {
      staticClass: "form-check-input",
      attrs: {
        "type": "radio",
        "name": "question-".concat(question.question_id, "-select-").concat(index),
        "id": "question-".concat(question.question_id, "-select-").concat(index),
        "disabled": ""
      },
      domProps: {
        "checked": question.selectedAnswer == 1,
        "value": 1
      }
    }), _c('label', {
      staticClass: "form-check-label"
    }, [_vm._v("Yes")])]), _c('div', {
      staticClass: "form-check form-check-inline"
    }, [_c('input', {
      staticClass: "form-check-input",
      attrs: {
        "type": "radio",
        "name": "question-".concat(question.question_id, "-unselect-").concat(index),
        "id": "question-".concat(question.question_id, "-unselect-").concat(index),
        "disabled": ""
      },
      domProps: {
        "checked": question.selectedAnswer == 0,
        "value": 0
      }
    }), _c('label', {
      staticClass: "form-check-label"
    }, [_vm._v("No")])]), question.selectedAnswer == 1 ? [question.medConditions.length > 0 ? _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-bordered mt-3"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Condition/Disease/ Diagnosis/Treatment")]), _c('th', [_vm._v("Date of Onset (MM/DD/YYYY)")]), _c('th', [_vm._v("Date of Recovery (MM/DD/YYYY)")]), _c('th', [_vm._v("Current Treatment")]), _c('th', [_vm._v("Taking Medication")]), _c('th', [_vm._v("Date Last Seen By Physician (MM/DD/YYYY)")]), _c('th', [_vm._v("Remaining Symptoms or Problems? Surgery or Hospitalization?")])])]), _c('tbody', [question.medConditions.length === 0 ? [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "7"
      }
    }, [_vm._v("No Data found")])])] : _vm._l(question.medConditions, function (condition, condIndex) {
      return _c('tr', {
        key: condIndex
      }, [_c('td', [_vm._v(_vm._s(condition.health_condition || 'N/A'))]), _c('td', [_vm._v(_vm._s(condition.date_of_onset || 'N/A'))]), _c('td', [_vm._v(_vm._s(condition.date_of_recovery || 'N/A'))]), _c('td', [_vm._v(_vm._s(_vm.stringifyAnswer(condition.is_treatment)))]), _c('td', [_vm._v(_vm._s(_vm.stringifyAnswer(condition.is_medicate)))]), _c('td', [_vm._v(_vm._s(condition.d_last_seen || 'N/A'))]), _c('td', [_vm._v(_vm._s(condition.symptoms || 'N/A'))])]);
    })], 2)])]) : _vm._e()] : _vm._e()], 2)])]);
  }), _vm.health_questions.length > 0 ? [_c('div', [_c('p', [_vm._v("Additional Notes")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.health_questions[0].additionalNotes,
      expression: "health_questions[0].additionalNotes"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": _vm.health_questions[0].additionalNotes
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.health_questions[0], "additionalNotes", $event.target.value);
      }
    }
  })])] : _vm._e()], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }